module.exports = __webpack_public_path__ + "media/images/vendors/category1-2265a02f558a1200239347fdac6509d5.jpg";